var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon24Uplad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-24-uplad",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding_box",
    "data-name": "Bounding box",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_color",
    "data-name": "Icon color",
    d: "M16.5,16H5A5,5,0,1,1,5,6a6,6,0,0,1,11.912-.979A5.5,5.5,0,0,1,16.5,16ZM11,4a.5.5,0,0,0-.354.148L7.112,7.684a.5.5,0,0,0,0,.707l.207.207a.493.493,0,0,0,.353.148H9V12.5a.5.5,0,0,0,.5.5h3a.5.5,0,0,0,.5-.5V8.745h1.328a.494.494,0,0,0,.354-.148l.207-.207a.5.5,0,0,0,0-.707L11.354,4.148A.5.5,0,0,0,11,4Z",
    transform: "translate(1 4)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon24Uplad);
export default __webpack_public_path__ + "static/media/icon-24-uplad.9b7989b66cc4d63e0e9bc3738729dc1e.svg";
export { ForwardRef as ReactComponent };